import { render, staticRenderFns } from "./MobileHomeConnection.vue?vue&type=template&id=197f1bf6&lang=pug&"
import script from "./MobileHomeConnection.vue?vue&type=script&lang=js&"
export * from "./MobileHomeConnection.vue?vue&type=script&lang=js&"
import style0 from "./MobileHomeConnection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports